<div class='risk-heat-bar' data-placement="top" data-toggle="tooltip" [attr.title]='tooltip' [template]='template' enTooltip>
  <div class='risk-heat-bar-label {{ riskNormalized }}'>
    {{ riskLabel }}
  </div>
</div>
